module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_right.108cc1e8.png";